import { render, staticRenderFns } from "./personSurcharge.vue?vue&type=template&id=ff7a0fce&"
import script from "./personSurcharge.vue?vue&type=script&lang=js&"
export * from "./personSurcharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff7a0fce')) {
      api.createRecord('ff7a0fce', component.options)
    } else {
      api.reload('ff7a0fce', component.options)
    }
    module.hot.accept("./personSurcharge.vue?vue&type=template&id=ff7a0fce&", function () {
      api.rerender('ff7a0fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20tEJVp73l7Q0/JS/personSurcharge.vue"
export default component.exports